import * as Sentry from '@sentry/react'

// Sentry: client-side error tracking + opt-in trace + replays-on-error.
//
// Privacy decisions baked in:
//   - maskAllText: true        — replays redact every text node (no leaked
//     receipts, recipes, item names, member emails)
//   - blockAllMedia: true      — receipt photos / recipe scans never travel
//   - replaysSessionSampleRate 0 + replaysOnErrorSampleRate 1 — replays are
//     only attached to error events, never recorded in steady state
//   - tracesSampleRate 0.1 in prod — trace 10% of pageloads/transactions for
//     performance work without burning the 5k events/month free tier

const DSN = import.meta.env.VITE_SENTRY_DSN_CLIENT

export function initSentry() {
  if (!DSN) {
    console.warn('Sentry DSN not configured — skipping init')
    return
  }

  Sentry.init({
    dsn:         DSN,
    environment: import.meta.env.MODE,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText:   true,
        blockAllMedia: true,
      }),
    ],
    tracesSampleRate:        import.meta.env.MODE === 'production' ? 0.1 : 1.0,
    replaysSessionSampleRate: 0.0,
    replaysOnErrorSampleRate: 1.0,
    beforeSend(event) {
      // Filter out localhost noise so dev-only errors don't burn the quota.
      if (event.request?.url?.includes('localhost')) return null
      return event
    },
  })
}

export function setSentryUser(
  user: { id: string; email?: string; household_id?: string } | null,
) {
  if (user) {
    Sentry.setUser({
      id:           user.id,
      email:        user.email,
      household_id: user.household_id,
    })
  } else {
    Sentry.setUser(null)
  }
}
